import { render } from "./LocalizedHtmlEditor.vue?vue&type=template&id=256c6eba&scoped=true"
import script from "./LocalizedHtmlEditor.vue?vue&type=script&lang=js"
export * from "./LocalizedHtmlEditor.vue?vue&type=script&lang=js"

import "./LocalizedHtmlEditor.vue?vue&type=style&index=0&id=256c6eba&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256c6eba"]])

export default __exports__